import React from 'react';
import PropTypes from 'prop-types';
import { Table, Dropdown, Icon } from 'semantic-ui-react';

export const LocationContactAction = {
  EDIT: 'Edit Contact',
};

// Component for dropdown items
const SelectableItem = ({
  value, text, disabled, onSelectAction,
}) => (
  <Dropdown.Item
    text={text}
    value={value}
    onClick={disabled ? undefined : (e, data) => onSelectAction(e, data)}
    style={disabled ? { color: 'gray', pointerEvents: 'none', opacity: 0.5 } : {}}
  />
);

SelectableItem.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelectAction: PropTypes.func.isRequired,
};

SelectableItem.defaultProps = {
  disabled: false,
};

const ContactListRowComponent = ({
  contact,
  index,
  actionHandler,
  hasLocationName,
  isAuctionLocationEditor,
}) => {
  // Helper function to handle action selection
  const onSelectAction = (e, data) => {
    e.preventDefault();
    const action = data.value;
    actionHandler(contact, action);
  };

  // Helper function to render status icons
  const renderStatusIcon = isActive => (
    <Icon
      color={isActive ? 'green' : 'red'}
      name={isActive ? 'checkmark' : 'close'}
      size='large'
    />
  );

  return (
    <Table.Row key={index}>
      {/* Render auction name if hasLocationName is true */}
      {hasLocationName && (
        <Table.Cell className='space-pre-wrap word-break-word'>
          {contact.auctionName || ''}
        </Table.Cell>
      )}
      <Table.Cell className='space-pre-wrap word-break-word'>
        {contact.contactName || ''}
      </Table.Cell>
      <Table.Cell className='space-pre-wrap word-break-word'>
        {contact.title || ''}
      </Table.Cell>
      <Table.Cell
        className={
          contact.isBlockedEmail
            ? 'error-text word-break-word'
            : 'word-break-word'
        }
      >
        {contact.contactEmail || ''}
      </Table.Cell>
      <Table.Cell className='word-break-word'>{contact.phone || ''}</Table.Cell>
      <Table.Cell className='word-break-word'>
        {contact.contactType || ''}
      </Table.Cell>
      {/* Render status icons */}
      <Table.Cell>
        <div className='text-center'>
          {renderStatusIcon(contact.guaranteeConfirm)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {renderStatusIcon(contact.guaranteeCancel)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>{renderStatusIcon(contact.returns)}</div>
      </Table.Cell>
      <Table.Cell>
        <div className='text-center'>
          {renderStatusIcon(contact.vehNotCovered)}
        </div>
      </Table.Cell>
      {/* Dropdown for actions */}
      <Table.Cell>
        <Dropdown
          text='Actions'
          pointing='top right'
          icon='ellipsis horizontal'
          className='no-pointer-dropdown'
        >
          <Dropdown.Menu>
            <SelectableItem
              text={LocationContactAction.EDIT}
              value={LocationContactAction.EDIT}
              disabled={!isAuctionLocationEditor}
              onSelectAction={onSelectAction}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  );
};

ContactListRowComponent.propTypes = {
  contact: PropTypes.shape({
    auctionName: PropTypes.string,
    contactName: PropTypes.string,
    title: PropTypes.string,
    isBlockedEmail: PropTypes.bool,
    contactEmail: PropTypes.string,
    phone: PropTypes.string,
    contactType: PropTypes.string,
    guaranteeConfirm: PropTypes.bool,
    guaranteeCancel: PropTypes.bool,
    returns: PropTypes.bool,
    vehNotCovered: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  actionHandler: PropTypes.func.isRequired,
  hasLocationName: PropTypes.bool,
  isAuctionLocationEditor: PropTypes.bool,
};

ContactListRowComponent.defaultProps = {
  hasLocationName: false,
  isAuctionLocationEditor: false,
};

const ContactListRow = (actionHandler, hasLocationName, isAuctionLocationEditor) => (contact, index) => (
  <ContactListRowComponent
    contact={contact}
    index={index}
    actionHandler={actionHandler}
    hasLocationName={hasLocationName}
    isAuctionLocationEditor={isAuctionLocationEditor}
  />
);

export default ContactListRow;
